"use client";
import * as React from "react";
const SvgPlayCircleRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 720 800", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M303 285v230q0 18 15.5 27t30.5-1l181-116q14-9 14-25t-14-25L349 259q-15-10-30.5-1T303 285zm97 515q-82 0-155-31.5t-127.5-86Q63 628 31.5 555T0 400q0-82 31.5-155t86-127.5Q172 63 245 31.5T400 0q82 0 155 31.5t127.5 86Q737 172 768.5 245T800 400q0 82-31.5 155t-86 127.5Q628 737 555 768.5T400 800zm0-400zm0 340q140 0 240-100t100-240q0-140-100-240T400 60q-140 0-240 100T60 400q0 140 100 240t240 100z" }));
export {
  SvgPlayCircleRound as default
};
